// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {

  --fontFamily: Roboto, sans-serif;
  --mainBackground: #fff;
  --dimBackground: #f9fafb;
  --mainForeground: #262626;
  --dimForeground: #6d7283;
  --primaryForeground: #315efb;
  --successForeground: #28bc00;
  --warningForeground: #f4c914;
  --failureForeground: #ff564e;
  --lightGrayBlue: #e8eaf0;
  --greyishBlue: #6674a6;
  --cloudGray: #8d96b2;
  --battleshipGrey: #62687f;
  --carbone: #343b4c;
}

.src-components-InlineForm-styles--root--LmIJI {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  padding: 20px 10px;
}

@media screen and (min-width: 768px) {

.src-components-InlineForm-styles--root--LmIJI {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-left: 0;
    padding-right: 0;
}
  }

.src-components-InlineForm-styles--root--LmIJI + section::before,.src-components-InlineForm-styles--root--LmIJI + form::before {
    position: absolute;
    top: -1px;
    left: 0;
    right: 0;
    height: 1px;
    background-color: #e8eaf0;
    background-color: var(--lightGrayBlue);
    content: '';
  }

@media screen and (min-width: 768px) {

.src-components-InlineForm-styles--root--LmIJI > section,
.src-components-InlineForm-styles--root--LmIJI > section + span {
    margin-right: 10px;
}
  }

.src-components-InlineForm-styles--root--LmIJI > section {
  margin-bottom: 15px;
}

@media screen and (min-width: 768px) {

.src-components-InlineForm-styles--root--LmIJI > section {
    flex: 1 1;
    margin-bottom: 0;
}
  }

.src-components-InlineForm-styles--root--LmIJI > span:last-child {
  float: right;
  margin-top: 11px;
}

@media screen and (min-width: 768px) {

.src-components-InlineForm-styles--root--LmIJI > span:last-child {
    float: none;
    margin-left: 15px;
    margin-right: 0;
}
  }
`, "",{"version":3,"sources":["webpack://./src/utils/variables.css","webpack://./src/components/InlineForm/styles.css"],"names":[],"mappings":"AAAA;;EAQE,gCAAgC;EAChC,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;AACpB;;ACpBA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AAoBpB;;AAlBE;;AANF;IAOI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AAapB;EAZE;;AAEA;IAEE,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,yBAAsC;IAAtC,sCAAsC;IACtC,WAAW;EACb;;AAKA;;AAFF;;IAGI,kBAAkB;AAEtB;EADE;;AAGF;EACE,mBAAmB;AAMrB;;AAJE;;AAHF;IAII,SAAO;IACP,gBAAgB;AAEpB;EADE;;AAGF;EACE,YAAY;EACZ,gBAAgB;AAOlB;;AALE;;AAJF;IAKI,WAAW;IACX,iBAAiB;IACjB,eAAe;AAEnB;EADE","sourcesContent":[":root {\n  @custom-media --mobile screen and (width < 768px);\n  @custom-media --desktop screen and (width >= 768px);\n  @custom-media --desktop-l screen and (width >= 1024px);\n  @custom-media --desktop-x screen and (width >= 1280px);\n  @custom-media --desktop-xl screen and (width >= 1440px);\n  @custom-media --iphone screen and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 2);\n\n  --fontFamily: Roboto, sans-serif;\n  --mainBackground: #fff;\n  --dimBackground: #f9fafb;\n  --mainForeground: #262626;\n  --dimForeground: #6d7283;\n  --primaryForeground: #315efb;\n  --successForeground: #28bc00;\n  --warningForeground: #f4c914;\n  --failureForeground: #ff564e;\n  --lightGrayBlue: #e8eaf0;\n  --greyishBlue: #6674a6;\n  --cloudGray: #8d96b2;\n  --battleshipGrey: #62687f;\n  --carbone: #343b4c;\n}\n","@import 'utils/variables.css';\n\n.root {\n  position: relative;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 20px 10px;\n\n  @media (--desktop) {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  & + section::before,\n  & + form::before {\n    position: absolute;\n    top: -1px;\n    left: 0;\n    right: 0;\n    height: 1px;\n    background-color: var(--lightGrayBlue);\n    content: '';\n  }\n}\n\n.root > section,\n.root > section + span {\n  @media (--desktop) {\n    margin-right: 10px;\n  }\n}\n\n.root > section {\n  margin-bottom: 15px;\n\n  @media (--desktop) {\n    flex: 1;\n    margin-bottom: 0;\n  }\n}\n\n.root > span:last-child {\n  float: right;\n  margin-top: 11px;\n\n  @media (--desktop) {\n    float: none;\n    margin-left: 15px;\n    margin-right: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `src-components-InlineForm-styles--root--LmIJI`
};
module.exports = ___CSS_LOADER_EXPORT___;
